
export default class RichText {
	static init() {

		this.editorImages = document.querySelectorAll('.rich-text img');
		this.editorImages.forEach( (img) => {
			let link = img.closest('a');
			if( link ){
				link.classList.add('image-pswp');
				link.setAttribute('data-pswp-src', img.src);
				link.setAttribute('data-pswp-width', img.getAttribute('width'));
				link.setAttribute('data-pswp-height', img.getAttribute('height'));
				link.setAttribute('data-pswp-alt', img.getAttribute('alt'));
			}
		});

	}

}
